import type { RiskLevel } from '@luminis/protocol';
import { RISK_DESCRIPTIONS, RISK_LABELS, RISK_TONES, isHighRisk } from '../lib/approval';

export function RiskBadge({
  risk,
  showDescription = false,
}: {
  risk: RiskLevel;
  showDescription?: boolean;
}) {
  return (
    <span className="inline-flex flex-col gap-1">
      <span
        className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium ${RISK_TONES[risk]}`}
      >
        {isHighRisk(risk) ? <span aria-hidden="true">⚠</span> : null}
        {RISK_LABELS[risk]} · {risk}
      </span>
      {showDescription ? (
        <span className="text-[11px] text-slate-400">{RISK_DESCRIPTIONS[risk]}</span>
      ) : null}
    </span>
  );
}
